import { render, staticRenderFns } from "./MultiInputDash.vue?vue&type=template&id=6f88766a&scoped=true"
import script from "./MultiInputDash.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiInputDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MultiInputDash.vue?vue&type=style&index=0&id=6f88766a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88766a",
  null
  
)

export default component.exports